window.hoculus = window.hoculus || {};
console.log(`%c
	██╗  ██╗ ██████╗  ██████╗██╗   ██╗██╗     ██╗   ██╗███████╗
	██║  ██║██╔═══██╗██╔════╝██║   ██║██║     ██║   ██║██╔════╝
	███████║██║   ██║██║     ██║   ██║██║     ██║   ██║███████╗
	██╔══██║██║   ██║██║     ██║   ██║██║     ██║   ██║╚════██║
	██║  ██║╚██████╔╝╚██████╗╚██████╔╝███████╗╚██████╔╝███████║
	╚═╝  ╚═╝ ╚═════╝  ╚═════╝ ╚═════╝ ╚══════╝ ╚═════╝ ╚══════╝
`, 'color: cyan; text-shadow: 2px 2px 5px blue;');

hoculus.Utils = class {
	static setCookie(name, value, minutes) {
		var expires = "";
		if (minutes) {
			var date = new Date();
			date.setTime(date.getTime() + (minutes * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	};

	static getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	};

	static async domreadyState() {
		return await new Promise(function (resolve, reject) {
			document.onreadystatechange = () => {
				if (document.readyState === "complete") {
					resolve(true);
				}
			};
		});
	}

	static async getScriptAsync(source, isModule = false, isNoModule = false) {
		return await new Promise(function (resolve, reject) {
			hoculus.loadedScripts = hoculus.loadedScripts || [];
			if (hoculus.loadedScripts.includes(source) || source == "") {
				resolve(true);
			} else {
				var script = document.createElement("script");
				var prior = document.getElementsByTagName("script")[0];

				script.defer = 1;
				
				if (isModule) script.type = "module";
				if (isNoModule) script.noModule = 1;

				script.onload = script.onreadystatechange = function (_, isAbort) {
					if (
						isAbort ||
						!script.readyState ||
						/complete/.test(script.readyState)
					) {
						script.onload = script.onreadystatechange = null;
						script = undefined;

						if (!isAbort) setTimeout(resolve(true), 50);
					}
				};

				script.src = source;
				prior.parentNode.insertBefore(script, prior);
			}
		});
	}

	static async getCssAsync(css) {
		hoculus.inProgressAssets = hoculus.inProgressAssets || [];
		hoculus.loadedAssets = hoculus.loadedAssets || [];

		return await new Promise(function (resolve, reject) {
			if (hoculus.loadedAssets.includes(css) || css == "") return resolve(true);

			if (hoculus.inProgressAssets.includes(css)) this.asyncAssetsInterval(css, resolve, reject);
			else {
				hoculus.inProgressAssets.push(css);

				// Generate link tag
				let link = document.createElement("link");
				link.setAttribute("rel", "stylesheet");
				link.setAttribute("href", css);

				link.onload = function () {
					hoculus.loadedAssets.push(css);
					resolve(true);
				};

				link.onerror = function () {
					hoculus.inProgressAssets.splice(hoculus.inProgressAssets.indexOf(css), 1);
					reject("CSS not loaded");
				};

				document.head.appendChild(link);
			}
		});
	}

    static getObserver({ callback = (entry) => {}, config = {} }) {
        return new IntersectionObserver(
            (entries) => entries.forEach(callback),
            { threshold: 0, ...config }
        );
    }

	static debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

	static waitForInteraction(events) {
        const interactionEvents = events ?? [
            "click",
            "keydown",
            "mousemove",
            "touchstart",
            "scroll"
        ]; // Use default events if none are provided

        return new Promise(resolve => {
            // Add event listeners for interaction events
            interactionEvents.forEach(event => {
                window.addEventListener(event, resolve, { once: true });
            });
        });
    }
}

hoculus.Clarity = class {
	constructor(id) {
		this.init(window, document, "clarity", "script", id);
	}

	init(c, l, a, r, i, block = false) {
		c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
		const t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
		if (block == true) {
			t.type = "text/plain";
			t.dataset.cookieType = "analytics";
		}
		const y = l.getElementsByTagName(r)[0];
		y.parentNode.insertBefore(t, y);
	}
}

hoculus.Utils.domreadyState().then(async () => {


	// ! ---- The code below will run after user interaction ----
	await hoculus.Utils.waitForInteraction();

	// Init Clarity after interaction
	if (hoculus.globalSettings.clarity.isActive && hoculus.globalSettings.clarity.id && window.Shopify.theme.role == 'main') new hoculus.Clarity(hoculus.globalSettings.clarity.id);
});